export function filterTime(value, flag) {
  let date = new Date(value);
  let y = date.getFullYear();
  let MM = date.getMonth() + 1;
  MM = MM < 10 ? ('0' + MM) : MM;
  let d = date.getDate();
  d = d < 10 ? ('0' + d) : d;
  let h = date.getHours();
  h = h < 10 ? ('0' + h) : h;
  let m = date.getMinutes();
  m = m < 10 ? ('0' + m) : m;
  let s = date.getSeconds();
  s = s < 10 ? ('0' + s) : s;
  if(flag === 'time') {
    return y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s;
  } else if (flag === 'date') {
    return y + '-' + MM + '-' + d;
  } else if (flag === 'y') {
    return y;
  } else if(flag === 'm') {
    return MM;
  } else if(flag === 'd') {
    return d;
  }
}





/**
 * 获取面包屑数据数组
 * @param {int} moduleId 栏目ID
 * @param {array} moduleTree 所有栏目Tree
 * @returns 
 */
export function getBreadcrumbs(moduleId, moduleTree) {
  let modules = []
  const recursive = (id, path, list) => {
    if (list.length == 0) return
    for (const item of list) {
      path.push(item)
      if (item.id == id) {
        modules = JSON.parse(JSON.stringify(path))
        return
      }
      const childs = item.childs || []
      recursive(id, path, childs)
      path.pop()
    }
  }
  recursive(moduleId, [], moduleTree)
  return modules
}



// WEBPACK FOOTER //
// ./src/common/js/common.js